module.exports = __webpack_public_path__ + "img/map-2.68621e41.svg";